import { render, staticRenderFns } from "./FormCustomerFinally.vue?vue&type=template&id=98bb38d6&scoped=true"
import script from "./FormCustomerFinally.vue?vue&type=script&lang=js"
export * from "./FormCustomerFinally.vue?vue&type=script&lang=js"
import style0 from "./FormCustomerFinally.vue?vue&type=style&index=0&id=98bb38d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98bb38d6",
  null
  
)

export default component.exports